import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'extractDay',
})
export class ExtractDayPipe implements PipeTransform {
  transform(value: any): any {
    const values = value?.split('/');
    if (values?.length > 1) {
      return values[1].replace(/^0+/, '');
    } else {
      return value;
    }
  }
}
